module.exports = __webpack_public_path__ + "resources/img/img_plantpulse.534a3957e458dac17392ba402de77856.png";